import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/apiAuth";

export const getUsersByType = createAsyncThunk(
  "users/getUsersByType",
  async (
    { userType, page = 1, limit = 10, search = "" },
    { rejectWithValue }
  ) => {
    try {
      const url = `/users/type/${userType.toUpperCase()}?page=${page}&limit=${limit}${
        search ? `&search=${search}` : ""
      }`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      let errorMessage = "Bilinmeyen bir hata oluştu";

      if (error.response) {
        errorMessage =
          error.response.data?.message ||
          error.response.data ||
          "Sunucu hatası";
      } else if (error.message) {
        errorMessage = error.message;
      }

      return rejectWithValue(errorMessage);
    }
  }
);
